import { Product } from "@shared/types";

export function createIndividualVariantProducts(products: Product[]): Product[] {
  return products.flatMap<Product>(({ variants = [], ...product }) =>
    variants.map((variant) => ({
      ...product,
      variants: [variant],
    }))
  );
}

export function readableBatchId(batchId?: string) {
  if (!batchId) {
    return ``;
  }
  return batchId.slice(-5).toUpperCase();
}

export const generateTestId = (component: string, description: string, index?: number | string) => {
  let testId = `${component}-${description}`;
  if (index !== undefined) {
    testId += `-${index}`;
  }
  return testId;
};

export const isSameObject = (a: unknown, b: unknown) => {
  if (JSON.stringify(a) === JSON.stringify(b)) {
    return true;
  }
  return false;
};

export const setFilterButtonTestId = (index?: number | string) => {
  return generateTestId("DataTable", "Filter-Button", index);
};
export const setFilterBadgeTestId = (index?: number | string) => {
  return generateTestId("DataTable", "Filter-Badge", index);
};
